import React from 'react';
import { Link } from 'react-router-dom';
import { FiGithub, FiMail } from 'react-icons/fi';
import { FaDiscord } from 'react-icons/fa';
import './Footer.css';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            {/* <img src="/logo.png" alt="CodeTunez Studios" className="footer__logo-img" /> */}
            <span className="footer__logo-text">
              CodeTunez<span className="footer__logo-accent"> Studios</span>
            </span>
          </Link>
          <p className="footer__tagline">
            Building software and producing original<br />digital art &amp; video content.
          </p>
          <div className="footer__social">
            <a
              href="https://github.com/CodeTunez-Studios"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="CodeTunez Studios GitHub"
            >
              <FiGithub />
            </a>
            <a
              href="https://discord.com/@codetunez"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="CodeTunez Discord"
            >
              <FaDiscord />
            </a>
            <a href="mailto:contact@codetunezstudios.com" aria-label="Email CodeTunez Studios Support">
              <FiMail />
            </a>
          </div>
        </div>

        <div className="footer__links-group">
          <h4 className="footer__group-title">Company</h4>
          <ul>
            <li><a href="/#about" onClick={e => { e.preventDefault(); scrollTo('about'); }}>About</a></li>
            <li><a href="/#software" onClick={e => { e.preventDefault(); scrollTo('software'); }}>Software</a></li>
            <li><Link to="/blog">Blog</Link></li>
          </ul>
        </div>

        <div className="footer__links-group">
          <h4 className="footer__group-title">Help</h4>
          <ul>
            <li><Link to="/support">Support Center</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>            
          </ul>
        </div>

      </div>

      <div className="footer__bottom">
        <div className="container">
          <p>© {year} CodeTunez Studios LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
